<template>
    <footer class="footer">
      <p>© {{ new Date().getFullYear() }} Miłosz Rolla - All Rights Reserved.</p>
    </footer>
  </template>
  
  <script setup>
  </script>
  
  <style scoped>
  .footer {
    text-align: center;
    padding: 20px;
    background-color: #000;
    color: white;
  }
  </style>
  